import React, { useEffect } from "react";
import { Button } from "../../../UI";
import { Box, Flex, useDisclosure } from "@chakra-ui/react";
import { useFormik } from "formik";
import { useMutateProgram } from "../../../../hooks/Programs/WorkshopsAndTraining";
import PartnerItem from "./PartnerItem";
import SearchBar from "./SearchBar";
import { GetFormData, GetNotification } from "../../../../Utils";

const EditPartners = ({ program, onCloseEdit }) => {
  const { mutate, isLoading, reset } = useMutateProgram(
    "EDIT-REGISTER-TO-PROGRAM",
  );
  const alreadyRegisteredPartners = program.registeredPartners.map(
    (partner) => ({ ...partner.partner, familyMembers: {} }),
  );
  const initialValues = {
    partnersIds: alreadyRegisteredPartners.map((partner) => partner._id),
    partnersData: alreadyRegisteredPartners,
  };

  const formik = useFormik({
    initialValues,
    validateOnChange: false,
    onSubmit: (values) => {
      const { _id: programId } = program;
      const formData = GetFormData(values, [], ["partnersIds", "partnersData"]);

      mutate(
        { programId, formData },
        {
          onSuccess: () => {
            reset();
            GetNotification.basic(
              "Socios modificados correctamente",
              "Aceptar",
            );
            onCloseEdit();
          },
          onError: (err) => {
            console.log(err);
            GetNotification.basic(
              "Error",
              "Aceptar",
              "Error al modificar socios",
              "error",
            );
            onCloseEdit();
          },
        },
      );
    },
  });

  const validateFromItems = () => {
    const isValid = formik.values.partnersData.filter(
      (partner) => partner.familyMembers?.isValid === false,
    ).length;

    return Boolean(isValid === 0);
  };

  const disableButtons =
    !validateFromItems() ||
    formik.values.partnersData.length === 0 ||
    isLoading;

  return (
    <Box p={4} borderWidth={1} borderColor={"green.100"} borderRadius={6}>
      <SearchBar formik={formik} />
      <Flex direction={"column"} justify={"center"} align={"center"} gap={1}>
        {formik.values?.partnersData?.map((item, index) => (
          <PartnerItem
            key={item._id}
            partner={item}
            formik={formik}
            type={"secondary"}
            index={index}
          />
        ))}
      </Flex>

      <Box mt={4} display={"flex"} justifyContent={"flex-end"} gap={2}>
        <Button
          text={"Cancelar"}
          bg={"beige.500"}
          color={"green.500"}
          bghover={"beige.600"}
          onClick={onCloseEdit}
          disabled={disableButtons || isLoading}
          isLoading={isLoading}
        />
        <Button
          text={"Aceptar"}
          bg={"green.500"}
          onClick={formik.submitForm}
          disabled={disableButtons || isLoading}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default EditPartners;
